"use client";
/*
 * Documentation:
 * GlossaryTooltip — https://app.subframe.com/4f62853ee923/library?component=GlossaryTooltip_2f0f9c8c-6ad9-440d-bf4a-ccd1466e9d5c
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface GlossaryTooltipRootProps
  extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode;
  className?: string;
}

const GlossaryTooltipRoot = React.forwardRef<
  HTMLDivElement,
  GlossaryTooltipRootProps
>(function GlossaryTooltipRoot(
  { children, className, ...otherProps }: GlossaryTooltipRootProps,
  ref
) {
  return (
    <div
      className={SubframeUtils.twClassNames(
        "flex flex-col items-start gap-2 rounded-md border border-solid border-[#000000] bg-[#000000] px-3 py-2 shadow-lg",
        className
      )}
      ref={ref}
      {...otherProps}
    >
      {children ? (
        <span className="text-caption font-caption text-[#ffffff]">
          {children}
        </span>
      ) : null}
    </div>
  );
});

export const GlossaryTooltip = GlossaryTooltipRoot;
